/**
 * SheetClip - Spreadsheet Clipboard Parser
 * version 0.2
 *
 * This tiny library transforms JavaScript arrays to strings that are pasteable by LibreOffice, OpenOffice,
 * Google Docs and Microsoft Excel.
 *
 * Copyright 2012, Marcin Warpechowski
 * Licensed under the MIT license.
 * http://github.com/warpech/sheetclip/
 */
function countQuotes(str) {
  return str.split("\"").length - 1;
}

export const SheetClip = {
  parse: function (str) {
    let r, rLen, rows, a = 0, c, cLen, multiline, last;
    const arr = [];

    rows = str.split("\n");

    if (rows.length > 1 && rows[rows.length - 1] === "") {
      rows.pop();
    }
    for (r = 0, rLen = rows.length; r < rLen; r += 1) {
      rows[r] = rows[r].split("\t");

      for (c = 0, cLen = rows[r].length; c < cLen; c += 1) {
        if (!arr[a]) {
          arr[a] = [];
        }
        if (multiline && c === 0) {
          last = arr[a].length - 1;
          arr[a][last] = arr[a][last] + "\n" + rows[r][0];

          // tslint:disable-next-line:no-bitwise
          if (multiline && (countQuotes(rows[r][0]) & 1)) {
            multiline = false;
            arr[a][last] = arr[a][last].substring(0, arr[a][last].length - 1).replace(/""/g, "\"");
          }
        } else {
          // tslint:disable-next-line:no-bitwise
          if (c === cLen - 1 && rows[r][c].indexOf("\"") === 0 && (countQuotes(rows[r][c]) & 1)) {
            arr[a].push(rows[r][c].substring(1).replace(/""/g, "\""));
            multiline = true;
          } else {
            arr[a].push(rows[r][c].replace(/""/g, "\""));
            multiline = false;
          }
        }
      }
      if (!multiline) {
        a += 1;
      }
    }

    return arr;
  },
  stringify: function (arr) {
    let r, rLen, c, cLen, str = "", val;

    for (r = 0, rLen = arr.length; r < rLen; r += 1) {
      cLen = arr[r].length;

      for (c = 0; c < cLen; c += 1) {
        if (c > 0) {
          str += "\t";
        }
        val = arr[r][c];

        if (typeof val === "string") {
          if (val.indexOf("\n") > -1) {
            str += "\"" + val.replace(/"/g, "\"\"") + "\"";
          } else {
            str += val;
          }
        } else if (val === null || val === void 0) {
          str += "";
        } else {
          str += val;
        }
      }

      if (r !== rLen - 1) {
        str += "\n";
      }
    }

    return str;
  }
};
